<template>
  <div class="member-edit">
    <div class="modal-header">
      <h2>{{ member.user_full_name }}</h2>
    </div>
    <form class="form--mod" action="post">
      <br />
      <label>Broj glasova po osnovu vlasništva</label>
      <input
        type="number"
        placeholder="Broj glasova na osnovu vlasništva"
        min="0"
        class="form-control"
        v-model="member.voting_points"
      />
      <br />
      <label>Opis</label>
      <input type="text" placeholder="Opis" class="form-control" v-model="member.div_desc" />
      <!-- <br />
      <input type="checkbox" name="menadzer" v-model="checkedManager" />
      Menadžer <br />
      <input type="checkbox" name="blagajnik" v-model="checkedCashier" />
      Blagajnik<br />-->
    </form>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="editMember"
        :disabled="loading"
      >
        <span v-if="!loading">Pošalji</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  created() {
    this.checkedManager = this.member.is_manager == 1 ? true : false;
    this.checkedCashier = this.member.is_cashier == 1 ? true : false;
  },
  computed: {
    ...mapState('modal', ['member']),
    ...mapState(['loading'])
  },
  data() {
    return {
      checkedManager: false,
      checkedCashier: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getActiveMembersByCommunity']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),

    editMember() {
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      let editRequest = {
        id: this.member.id,
        div_description: this.member.div_desc,
        voting_points: this.member.voting_points,
        is_manager: this.checkedManager == true ? 1 : 0,
        is_cashier: this.checkedCashier == true ? 1 : 0
      };
      axios
        .post('/member/edit', editRequest)
        .then(() => {
          this.getActiveMembersByCommunity(this.$route.params.id);
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped></style>
